import Vue from "vue";

Vue.component("file-upload-button", {
	props: ["acceptedFiles", "multiple", "attachments"],
	data() {
		return {
			fileData: [],
			files: [],
			forUploading: false,
			uploadLabel: window.labels.upload,
			uploadingText: window.labels.uploading,
			isMultipleUpload: this.multiple ? true : false,
		};
	},
	methods: {
		processFiles: function () {
			var val = this.files;
			this.$emit("update:attachments", val);
			this.$emit("input");
		}
	},
	watch: {
		attachments: function (val) {
			this.files = val;
		}
	},
	template: `
		<div class="columns">
			<div class="column">

				<b-field>
					<file-upload 
						@input="processFiles"
						:accept="acceptedFiles" 
						v-model="files"
						:multiple="isMultipleUpload" class="button is-danger"> {{ uploadLabel | decodeHTMLEntity }}
					</file-upload>
				</b-field>

			</div>
		</div>
	`
});